<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" fill="#F2C94C" />
    <rect x="7" y="8" width="3" height="11" fill="white" />
    <rect x="15" y="14" width="3" height="5" fill="white" />
    <rect x="11" y="5" width="3" height="14" fill="white" />
  </svg>
</template>

<script>
export default {
  name: "IceMap"
}
</script>


